"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeeMore = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Svg = require("./Svg");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var longArrow = function longArrow(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.828 6.99999L7.778 11.95L6.364 13.364L0 6.99999L6.364 0.635986L7.778 2.04999L2.828 6.99999Z",
    fill: "currentColor"
  }));
};
longArrow.defaultProps = {
  width: "8",
  height: "14",
  viewBox: "0 0 8 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var TextLink = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  cursor: pointer;\n\n  ", " {\n    margin-left: 10px;\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
}, _Svg.Svg, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});
var SeeMore = function SeeMore(_ref3) {
  var onClick = _ref3.onClick,
    children = _ref3.children;
  return /*#__PURE__*/_react.default.createElement(TextLink, {
    onClick: onClick
  }, children, /*#__PURE__*/_react.default.createElement(_Svg.Svg, {
    as: longArrow,
    rotate: 180
  }));
};
exports.SeeMore = SeeMore;